import React from 'react';
import { translate } from '../../translations/translator';
import { makeStyles } from '@mui/styles';
import selectorBackground from 'assets/images/counter.png';
import { remCalc } from '../../util/style-util';
const translateFooter = key => translate('footer', key);
type Props = {
  currentPage: number;
  totalPages: number | string;
  pageOffset: number;
  isZoom: boolean;
  toggleMenu?: (open?: boolean) => void;
  singlePage: boolean;
};

const PageSelector = ({
  currentPage,
  totalPages,
  pageOffset,
  isZoom,
  toggleMenu,
  singlePage
}: Props) => {
  const { pageSelector, pointerCursor } = useStyles();

  const currentPageRange = (): string | number => {
    if (Number.isNaN(currentPage)) return translateFooter('cover');
    if (currentPage === 0) {
      if (pageOffset === 0) {
        return singlePage ? '1' : '1 - 2';
      } else {
        return singlePage ? 'i' : 'i - 1';
      }
    }
    if (currentPage === totalPages || isZoom || singlePage) return currentPage;

    return `${currentPage} - ${currentPage + 1}`;
  };

  const handleClick = () => toggleMenu && toggleMenu();
  return (
    <div
      onClick={handleClick}
      className={`${pageSelector} ${toggleMenu && pointerCursor ? pointerCursor : ''}`}
    >
      <span>
        {currentPageRange()} {translateFooter('of')} {totalPages}
      </span>
    </div>
  );
};

const useStyles = makeStyles(() => {
  return {
    pageSelector: {
      width: remCalc(170),
      height: remCalc(48),
      backgroundColor: 'transparent',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${selectorBackground})`,
      paddingTop: remCalc(5),
      textAlign: 'center',
      transform: 'translateY(-5%)',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex'
    },
    pointerCursor: {
      cursor: 'pointer'
    }
  };
});

PageSelector.defaultProps = {
  totalPages: '-'
};

export default PageSelector;
